<template>
  <div class="td-index"></div>
</template>

<script>
import wxService from "../_services/wx.service";
export default {
  name: "TianDingIndexComponent",
  data() {},
  mounted() {
    this.indicator$.open("正在加载...");
    let uri = "|/tdLogin|d";
    wxService.getAuthorizationCode(process.env.NODE_ENV + uri);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/index.vue